<template>
  <div class="flex group/input-icon input-icon-group">
    <slot />
  </div>
</template>

<style lang="postcss" scoped></style>
